import angular = require("angular");
import {SessionService} from "../services/session";

export class ManageController {

    static $inject = ["$routeParams", "session", "$rootScope"];

    section;
    rootScope;
    session: SessionService;

    constructor($routeParams, session, $rootScope) {
      this.section = $routeParams.what;
      this.session = session;
      this.rootScope = $rootScope;

      switch (this.section) {
        case "upcoming":
          this.session.loadUpcomingEvents();
          break;
        case "hosted":
          this.session.loadHostedEvents();
          break;
        case "saved":
          this.session.loadSavedEvents();
          break;
        case "past":
          this.session.loadPastEvents();
          break;
      }
    }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/manage.ts
 **/